/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Cta_DescriptionInputs */

const en_directory_ai_tools_cta_description = /** @type {(inputs: Directory_Ai_Tools_Cta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Two selfies in, one rap duo video out, in a few minutes.`)
};

const zh_directory_ai_tools_cta_description = /** @type {(inputs: Directory_Ai_Tools_Cta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`两张自拍进去，一条说唱二人组视频出来，只要几分钟。`)
};

/**
* | output |
* | --- |
* | "Two selfies in, one rap duo video out, in a few minutes." |
*
* @param {Directory_Ai_Tools_Cta_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_cta_description = /** @type {((inputs?: Directory_Ai_Tools_Cta_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Cta_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_cta_description(inputs)
	return zh_directory_ai_tools_cta_description(inputs)
});
export { directory_ai_tools_cta_description as "directory.ai_tools.cta_description" }